var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCloudMobile = function SvgCloudMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 375 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.797 44.645c.352.527 5.913-5.34 6.283-5.911 7.909-12.24 45.691-23.986 83.436-4.172 4.464-3.037 8.547-5.9 12.365-8.578C187.1 9.702 200.535.281 230.433.281c26.797 0 42.495 8.492 56.825 16.244 4.287 2.32 8.452 4.572 12.755 6.512 18.872-14.861 35.439 5.398 42.526 15.697 11.666-14.984 32.926 5.169 33.456 10.091.047.433-.237.923-.782 1.456H0c14.694-18.885 45.014-30.688 61.797-5.636Z",
    fill: "currentColor"
  })));
};

export default SvgCloudMobile;